import { WMBaseItem } from "./baseitem";
const Utils = require("../utils").default;

export default class AccessCollection extends WMBaseItem {
  get customerId() {
    return this.dto.customerId;
  }

  upload_changes() {
    return this.Network.access_collection.update(this.id, this.changes());
  }

  static new_item_instance(dto, identification) {
    return new AccessCollection(dto, identification);
  }

  static find_parent(app, identification) {
    return app.$appm.get_customer(identification.customer_id).access_collections;
  }

  static find(app, id, identification) {
    return app.$appm.get_access_collection(identification.customer_id, id);
  }
  static delete_clientside(app, identification) {
    const array = app.grants;

    let grantIndex = -1;

    for (var i = 0; i < array.length; i++) {
      //console.log("checking", i, array[i], "collectionId=", array[i].dto.collectionId, "userId=", array[i].dto.userId);
      if ((array[i].dto.collectionId === identification.collection_id) && 
          (array[i].dto.userId === identification.user_id) &&
          (array[i].dto.customerId === identification.customer_id)) {
        grantIndex = i;
      }
    }
    if (grantIndex >= 0) {
      app.grants.splice(grantIndex, 1);
    }  
  }
}
